import AbiTradePartnerApiUrls from '../../../apiUrls/AbiTradePartnerApiUrls'
import { FileForUserGetPartyId } from '../../../common/FileForUserCommon'

export const fetchPartyLookup = async (partyCode, formSections) => {
  try {
    const response = await fetch(
      AbiTradePartnerApiUrls.GET +
        `?partyId=${FileForUserGetPartyId()}&partyCode=${partyCode}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        }
      }
    )

    if (!response.ok) {
      console.log('Error fetching party lookup')
      return []
    }

    const json = await response.json()

    if (formSections === 'header') {
      if (partyCode === 'IM' || partyCode === 'CN' || partyCode === 'DN') {
        return json.data.map((u) => ({
          value: `${u.taxIdNumber} - ${u.id}`,
          description: `${u.taxIdNumber} - ${u.name}`
        }))
      } else if (partyCode === 'FF') {
        return json.data.map((u) => ({
          value: u.taxIdNumber ? `${u.taxIdNumber} - ${u.id}` : u.id,
          description: u.taxIdNumber ? `${u.taxIdNumber} - ${u.name}` : u.name
        }))
      } else {
        return json.data.map((u) => ({
          value: u.id,
          description: u.partyMasterName
        }))
      }
    } else {
      return json.data.map((u) => ({
        value: u.id,
        description: u.partyMasterName
      }))
    }
  } catch (error) {
    console.log('Error fetching party lookup', error)
    return []
  }
}
